import React from 'react';
var QuoteCardSkeleton = function () {
    return (React.createElement("div", { className: "relative bg-white border border-gray-200 rounded-2xl p-5 flex flex-col animate-pulse" },
        React.createElement("div", { className: "flex items-center justify-between mb-4" },
            React.createElement("div", null,
                React.createElement("div", { className: "h-[15px] w-32 bg-gray-200 rounded mb-2" }),
                React.createElement("div", { className: "h-[11px] w-24 bg-gray-100 rounded" }))),
        React.createElement("div", { className: "bg-gray-50 rounded-lg p-4 mb-4 min-h-[120px] flex flex-col justify-center items-center" },
            React.createElement("div", { className: "loader p-2 w-[85px] bg-gray-200" })),
        React.createElement("div", { className: "border-t border-gray-200 pt-3 mb-4 space-y-2" }, [1, 2, 3].map(function (i) { return (React.createElement("div", { key: i, className: "flex justify-between items-center" },
            React.createElement("div", { className: "h-3 w-24 bg-gray-100 rounded" }),
            React.createElement("div", { className: "h-3 w-16 bg-gray-200 rounded" }))); })),
        React.createElement("div", { className: "space-y-2 flex flex-col h-full" },
            React.createElement("div", { className: "flex justify-center mt-auto mb-2" },
                React.createElement("div", { className: "h-4 w-40 bg-gray-100 rounded" })),
            React.createElement("div", { className: "space-y-2" },
                React.createElement("div", { className: "w-full h-10 bg-gray-200 rounded-lg" }),
                React.createElement("div", { className: "w-full h-8 bg-gray-50 rounded-lg" })))));
};
export default QuoteCardSkeleton;
